import { Roles } from '../constants';

/** Roles that sign in to the broker area (/broker/*) — pipeline and loan detail (view). */
export const BROKER_PORTAL_ROLES = [
  Roles.BrokerAdmin,
  Roles.Broker,
  Roles.Processor,
  Roles.BrokerFullAccessReadOnly,
];

/** Roles that may change loans, pricing, company settings, and imports (matches API write access). */
export const BROKER_MUTATION_ROLES = [
  Roles.BrokerAdmin,
  Roles.Broker,
  Roles.Processor,
];

export const isBrokerReadOnlyRole = (role) => role === Roles.BrokerFullAccessReadOnly;

export const canPerformBrokerMutations = (role) => BROKER_MUTATION_ROLES.includes(role);

export const isPendingBrokerCompany = (brokerCompanyStatus) => brokerCompanyStatus === 'Pending Approval';
